<template>
  <div class="change-theme">
    <button v-for="(themeName, key) in supportedThemes"
            :key="key"
            class="change-theme-button"
            :disabled="currentTheme.toLowerCase() === themeName.toLowerCase()"
            @click="changeTheme(themeName)"> {{ themeName }}
    </button>
  </div>
</template>

<script>

export default {
  name: 'themeSelector',
  model: {
    prop: 'currentTheme',
    event: 'changeTheme',
  },
  props: {
    currentTheme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      supportedThemes: ['Bloom', 'Sword', 'Big', 'Eco', 'Move'],
    };
  },
  methods: {
    changeTheme(themeName) {
      this.$emit('change-theme', themeName.toLowerCase());
    },
  },
};

</script>

<style lang="scss" scoped>
.change-theme {
  font-family: Helvetica, Arial, sans-serif;
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  background-color: rgba(33, 38, 45, 0.4);
  z-index: 2000;
}
</style>
